import React, { useState, useEffect } from 'react'
import { Select } from '../ui/Select'
import { SelectTrigger } from '../ui/SelectTrigger'
import { SelectValue } from '../ui/SelectValue'
import { SelectContent } from '../ui/SelectContent'
import { SelectItem } from '../ui/SelectItem'
import { useSearchParams } from 'react-router-dom'

interface Location {
  id: string
  location_name: string;
  location_city: string;
  location_country: string;
}

interface Department {
  id: string
  department_name: string
}

interface JobFiltersProps {
  locations: Location[]
  departments: Department[]
  primaryColor: string
}

const JobFilters: React.FC<JobFiltersProps> = ({ locations, departments, primaryColor }) => {
  const [lighterShade, setLighterShade] = useState<string | null>(null);
  // const [filters, setFilters] = useState({
  //   work: '',
  //   location: '',
  //   team: '',
  //   workType: ''
  // })
  const [searchParams, setSearchParams] = useSearchParams();

  const [filters, setFilters] = useState({
    work: searchParams.get('work') || '',
    location: searchParams.get('location') || '',
    team: searchParams.get('team') || '',
    workType: searchParams.get('workType') || ''
  });

  // Update filters when URL parameters change
  useEffect(() => {
    setFilters({
      work: searchParams.get('work') || '',
      location: searchParams.get('location') || '',
      team: searchParams.get('team') || '',
      workType: searchParams.get('workType') || ''
    });
  }, [searchParams]);

  // Update URL when filters change
  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    });
    setSearchParams(params);
  }, [filters]);


  // useEffect(() => {
  //   const params = new URLSearchParams()
  //   Object.entries(filters).forEach(([key, value]) => {
  //     if (value) {
  //       params.set(key, value)
  //     }
  //   })

  //   const newUrl = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`
  //   window.history.pushState({}, '', newUrl)
  // }, [filters])

  const workplaceTypes = [
    { value: 'On_site', label: 'On-site' },
    { value: 'Hybrid', label: 'Hybrid' },
    { value: 'Remote', label: 'Remote' }
  ]

  const workTypes = [
    { value: 'Full_Time', label: 'Full-time' },
    { value: 'Part_Time', label: 'Part-time' },
    { value: 'Contract', label: 'Contract' },
    { value: 'Internship', label: 'Internship' },
    { value: 'Temporary', label: 'Temporary' },
    { value: 'Volunteer', label: 'Volunteer' },
    { value: 'Other', label: 'Other' }
  ]

    useEffect(() => {
      if (primaryColor) {
        document.documentElement.style.setProperty('--component-primary-color', primaryColor);
        const lighter = calculateLighterShade(primaryColor, 0.26);
        const mainBgShare =  calculateLighterShade(primaryColor, 0.93);
        setLighterShade(lighter);
        document.documentElement.style.setProperty('--hover-primary-color', lighter);
        document.documentElement.style.setProperty('--main-bg-color', mainBgShare);
      }
    }, [primaryColor]);

        // Helper function to calculate lighter shade for hover state
        const calculateLighterShade = (hex: any, percent: any) => {
          // Remove the hash if it exists
          hex = hex.replace('#', '');
      
          // Convert hex to RGB
          let r = parseInt(hex.substring(0, 2), 16);
          let g = parseInt(hex.substring(2, 4), 16);
          let b = parseInt(hex.substring(4, 6), 16);
      
          // Calculate lighter values (adding the percentage)
          r = Math.min(255, Math.round(r + (255 - r) * percent));
          g = Math.min(255, Math.round(g + (255 - g) * percent));
          b = Math.min(255, Math.round(b + (255 - b) * percent));
      
          // Convert back to hex
          const toHex = (n: any) => {
            const hex = n.toString(16);
            return hex.length === 1 ? '0' + hex : hex;
          };
      
          return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
        };


  return (
 <>
 {/* desktop */}
    <div className="sm:flex hidden gap-4">
      <Select
        value={departments.find(dep => dep.id === filters.team)?.department_name || ""}
        onValueChange={(value: string) => {
          const selectedDepartment = departments.find(dep => dep.department_name === value)
          setFilters(prev => ({ ...prev, team: selectedDepartment?.id || "" }))
        }}
      >
        <SelectTrigger className="w-[150px] bg-gray-100">
          <SelectValue placeholder="Department" />
        </SelectTrigger>
        <SelectContent>
          {departments.map((department) => (
            <SelectItem key={department.id} value={department.department_name}>
              {department.department_name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        // value={filters.work}
        // onValueChange={(value: string) => setFilters(prev => ({ ...prev, work: value }))}
        value={workplaceTypes.find(type => type.value === filters.work)?.label || ""}
        onValueChange={(label: string) => {
          const selectedType = workplaceTypes.find(type => type.label === label);
          setFilters(prev => ({ ...prev, work: selectedType?.value || "" }));
        }}
      >
        <SelectTrigger className="w-[150px] bg-gray-100">
          <SelectValue placeholder="Office Type" />
        </SelectTrigger>
        <SelectContent>
          {workplaceTypes.map((type) => (
            <SelectItem key={type.value} value={type.label}>
              {type.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={locations.find(loc => loc.id === filters.location)?.location_name || ""}
        onValueChange={(value: string) => {
          const selectedLocation = locations.find(loc => loc.location_name === value)
          setFilters(prev => ({ ...prev, location: selectedLocation?.id || "" }))
        }}
      >
        <SelectTrigger className="w-[150px] bg-gray-100">
          <SelectValue placeholder="Location" />
        </SelectTrigger>
        <SelectContent>
          {locations.map((location) => (
            <SelectItem key={location.id} value={location.location_name}>
              {location.location_name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>




      <Select
        value={workTypes.find(type => type.value === filters.workType)?.label || ""}
        onValueChange={(label: string) => {
          const selectedType = workTypes.find(type => type.label === label);
          setFilters(prev => ({ ...prev, workType: selectedType?.value || "" }));
        }}
      >
        <SelectTrigger className="w-[150px] bg-gray-100">
          <SelectValue placeholder="Job Type" />
        </SelectTrigger>
        <SelectContent>
          {workTypes.map((type) => (
            <SelectItem key={type.value} value={type.label}>
              {type.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

    </div>
 {/* mobile */}
    <div className="sm:hidden flex gap-4 flex-col">
    
     <div className='flex items-center gap-x-2'>
     <Select
        value={departments.find(dep => dep.id === filters.team)?.department_name || ""}
        onValueChange={(value: string) => {
          const selectedDepartment = departments.find(dep => dep.department_name === value)
          setFilters(prev => ({ ...prev, team: selectedDepartment?.id || "" }))
        }}
      >
        <SelectTrigger className="w-[150px] bg-gray-100">
          <SelectValue placeholder="Department" />
        </SelectTrigger>
        <SelectContent>
          {departments.map((department) => (
            <SelectItem key={department.id} value={department.department_name}>
              {department.department_name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        // value={filters.work}
        // onValueChange={(value: string) => setFilters(prev => ({ ...prev, work: value }))}
        value={workplaceTypes.find(type => type.value === filters.work)?.label || ""}
        onValueChange={(label: string) => {
          const selectedType = workplaceTypes.find(type => type.label === label);
          setFilters(prev => ({ ...prev, work: selectedType?.value || "" }));
        }}
      >
        <SelectTrigger className="w-[150px] bg-gray-100">
          <SelectValue placeholder="Office Type" />
        </SelectTrigger>
        <SelectContent>
          {workplaceTypes.map((type) => (
            <SelectItem key={type.value} value={type.label}>
              {type.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
     </div>

     <div className='flex items-center gap-x-2'>
      <Select
        value={locations.find(loc => loc.id === filters.location)?.location_name || ""}
        onValueChange={(value: string) => {
          const selectedLocation = locations.find(loc => loc.location_name === value)
          setFilters(prev => ({ ...prev, location: selectedLocation?.id || "" }))
        }}
      >
        <SelectTrigger className="w-[150px] bg-gray-100">
          <SelectValue placeholder="Location" />
        </SelectTrigger>
        <SelectContent>
          {locations.map((location) => (
            <SelectItem key={location.id} value={location.location_name}>
              {location.location_name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>




      <Select
        value={workTypes.find(type => type.value === filters.workType)?.label || ""}
        onValueChange={(label: string) => {
          const selectedType = workTypes.find(type => type.label === label);
          setFilters(prev => ({ ...prev, workType: selectedType?.value || "" }));
        }}
      >
        <SelectTrigger className="w-[150px] bg-gray-100">
          <SelectValue placeholder="Job Type" />
        </SelectTrigger>
        <SelectContent>
          {workTypes.map((type) => (
            <SelectItem key={type.value} value={type.label}>
              {type.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
</div>
    </div>
 </>
  )
}

export default JobFilters